"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log = void 0;
class Log {
    static applyData(message, cb) {
        return message.message.replace(/\$\{(\d{1,2})\}/gi, (_match, idx) => {
            return cb(message.data[idx], idx);
        });
    }
    static parse(message) {
        const regex = /(\$\{\d+\})/g;
        const parsedArray = message.message.split(regex).filter(Boolean);
        return parsedArray.map((item) => {
            if (item.startsWith('${') && item.endsWith('}')) {
                const idx = Number(item.substring(2, item.length - 1));
                return message.data[idx];
            }
            return item;
        });
    }
}
exports.Log = Log;
